// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2UMCB","content":"ManualTimeModal_content__3YL4f"};